module.exports = __webpack_public_path__ + "img/tottenham-hotspur.4665ac28.png";